<template>
  <div>
    <div class="vx-row mx-2">
      <div class="router-header flex flex-wrap items-center mb-6">
        <div
          class="content-area__heading pr-4 border-0 md:border-r border-solid border-grey-light"
        >
          <h2 class="mb-1">รายงานสถานะการติดตามเรือประมง</h2>
        </div>
        <!-- <p class="mx-5 mt-2">สถานะการเข้ารับน้ำมัน</p> -->
      </div>
    </div>
    <vx-card>
      <vs-row vs-w="12" class="my-5">
        <vs-col
          vs-type="flex"
          class="mb-1"
          vs-justify="center"
          vs-align="center"
          vs-lg="4"
          vs-sm="6"
          vs-xs="12"
        >
          <div class="h7 px-1">วันที่เริ่ม:</div>
          <v-date-picker
            v-model="dataSearchVessel.selectedDate"
            mode="dateTime"
            :masks="masks"
            is-range
            is24hr 
            :locale="$i18n.locale"
            :buddhist="true"
            :max-date="new Date()"
          >
            <template v-slot="{ inputValue, inputEvents }">
              <vs-button
                v-on="inputEvents.start"
                size="small"
                color="#cccccc"
                type="border"
                class="w-full text-left"
              >
                <div class="vx-row">
                  <vs-icon size="small" icon="today" color="dark"></vs-icon>
                  <h6 class="mt-1 mx-2">
                    {{setDateFormatTh(dataSearchVessel.selectedDate.start)}} -
                    {{setDateFormatTh(dataSearchVessel.selectedDate.end)}}
                  </h6>
                  <p hidden>{{inputValue}}</p>
                </div>
              </vs-button>
            </template>
          </v-date-picker>
        </vs-col>
        <vs-col
          vs-type="flex"
          class="mb-1"
          vs-align="center"
          vs-lg="3"
          vs-sm="2"
          vs-xs="12"
        >
          <div class="h7 px-1">MMSI:</div>
          <vs-input
            id="mmsi"
            v-model="dataSearchVessel.mmsi"
            class="w-full"
          /><br />
        </vs-col>
        <vs-col
          vs-type="flex"
          class="mb-1"
          vs-align="center"
          vs-lg="5"
          vs-sm="3"
          vs-xs="12"
        >
          <div class="h7 px-1">สถานะการเข้ารับน้ำมัน : </div>
          <v-select
            id="refuelEvent"
            :options="refuelEventOptions"
            v-model="dataSearchVessel.status"
            class="w-1/2 p-1"
            label="name"
          /><br />
          <vs-button
            class="py-2 px-5 ml-2"
            color="#0066cc"
            type="border"
            icon-pack="feather"
            icon="icon-search"
            @click="searchVessel()"
            >ค้นหา</vs-button
          >
        </vs-col>
      </vs-row>
      <!-- <hr class="my-10" /> -->
    </vx-card>

    <vx-card class="mt-5 z-0">
      <div class="px-5 pb-5 relative">
        <!-- <center>
          <vs-alert
            :active="statusLoadingVessel"
            color="primary"
            style="width: 90%"
            title="Loading...."
            >กำลังโหลดข้อมูลเรือ กรุณารอสักครู่...</vs-alert
          >
        </center> -->
        <h4 class="my-3">ผลการค้นหา</h4>
        <vs-table
          class="static"
          :max-items="descriptionItems[0]"
          description
          :description-items="descriptionItems"
          description-title="Registries"
          description-connector="of"
          description-body="Pages"
          pagination
          :data="refuelEvent"
        >
          <template slot="thead">
            <vs-th><p class="mx-auto">ลำดับ</p></vs-th>
            <vs-th><p class="mx-auto">MMSI</p></vs-th>
            <vs-th><p class="mx-auto">ชื่อเรือ</p></vs-th>
            <vs-th><p class="mx-auto">ละติจูด , ลองจิจูด</p></vs-th>
            <vs-th><p class="mx-auto">วันที่สำรองข้อมูล</p></vs-th>
            <vs-th><p class="mx-auto">วันที่บันทึก</p></vs-th>
            <vs-th><p class="mx-auto">สถานะการเข้ารับน้ำมัน</p></vs-th>
          </template>
          <template slot-scope="{ data }">
            <tbody>
              <vs-tr
                :key="indextr"
                v-for="(tr, indextr) in data"
                class="text-center"
              >
                <vs-td>{{ indextr + 1 }}</vs-td>
                <vs-td :data="data[indextr].mmsi">{{
                  data[indextr].mmsi
                }}</vs-td>
                <vs-td :data="data[indextr].vessel.name">{{
                  data[indextr].vessel.name
                }}</vs-td>
                <vs-td :data="data[indextr].vessel.latitude">
                  <a href="#" @click="isActiveNotification(data[indextr])">
                    {{ data[indextr].latitude }} , {{ data[indextr].longitude }}
                  </a>
                </vs-td>
                <vs-td :data="data[indextr].transmit_time">{{
                  data[indextr].transmit_time ? setDateFormatRecordTime(data[indextr].transmit_time, "datetime") : ''
                }}</vs-td>
                <vs-td :data="data[indextr].vessel.record_time">{{
                  setDateFormatRecordTime(data[indextr].record_time, "datetime")
                }}</vs-td>
                <vs-td :data="data[indextr].refuel_event">
                  <div class="align-middle flex justify-center">
                    <vs-chip v-if="data[indextr].refuel_event == 1" color="#fdecb4">
                      <p style="color: #000">เข้าเขตเรือรับน้ำมัน</p>
                    </vs-chip>
                    <vs-chip v-else-if="data[indextr].refuel_event == 2" color="#188d09">
                      <p>เข้ารับน้ำมัน</p>
                    </vs-chip>
                    <vs-chip v-else-if="data[indextr].refuel_event == 3" color="#ffe1c5">
                      <p style="color: #000">ออกจากการเข้ารับน้ำมัน</p>
                    </vs-chip>
                    <vs-chip v-else-if="data[indextr].refuel_event == 4" color="#fc7e2a">
                      <p>ออกนอกเขตเรือจ่ายน้ำมัน</p>
                    </vs-chip>
                    <vs-chip v-else color="gray">
                      <p>ปกติ</p>
                    </vs-chip>
                  </div>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
    </vx-card>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
import Datepicker from "vuejs-datepicker";
import moment from "moment-timezone";

export default {
  name: "RefuelEvent",
  components: {
    vSelect,
    Datepicker,
  },
  data() {
    return {
      descriptionItems: [10, 25, 50, 100],
      Datasuccess: [],
      masks: {
        input: 'YYYY-MM-DD H:mm',
        title: 'MMMM YYYY',
        weekdays: 'W',
        navMonths: 'MMM',
        dayPopover: 'WWW, MMM D, YYYY',
        data: ['L', 'YYYY-MM-DD', 'YYYY/MM/DD'],
      },
      dataSearchVessel: {
        mmsi: null,
        selectedDate: {
          start: new Date(),
          end: new Date(),
        },
        status: {
          id: 0,
          name: "ทั้งหมด",
          value: 0,
        },
      },
      refuelEventOptions: [
        {
          id: 0,
          name: "ทั้งหมด",
          value: 0,
        },
        {
          id: 1,
          name: "เข้าเขตเรือรับน้ำมัน",
          value: 1,
        },
        {
          id: 2,
          name: "เข้ารับน้ำมัน",
          value: 2,
        },
        {
          id: 3,
          name: "ออกจากการเข้ารับน้ำมัน",
          value: 3,
        },
        {
          id: 4,
          name: "ออกนอกเขตเรือจ่ายน้ำมัน",
          value: 4,
        },
      ],
    };
  },
  computed: mapState({
    refuelEvent: (state) => state.rts.refuelEvent,
  }),
  created() {
    this.searchVessel();
  },
  mounted() {},
  watch: {
  },
  methods: {
    async searchVessel() {
      this.$vs.loading();
      this.dataSearchVessel.selectedDate.start = this.setDateFormat(
        this.dataSearchVessel.selectedDate.start
      );
      this.dataSearchVessel.selectedDate.end = this.setDateFormat(
        this.dataSearchVessel.selectedDate.end
      );
      //   console.log("this.dataSearchVessel ", this.dataSearchVessel);
      await this.$store.dispatch("rts/getRtsRefuelEvent", this.dataSearchVessel);
        console.log("refuelEvent ", this.refuelEvent);
      this.$vs.loading.close();
    },
    setDateFormat(date) {
      return moment(date).format("YYYY-MM-DD H:mm");
    },
    setDateFormatRecordTime(date, type) {
      moment.locale("th"); // th
      if (type == "date") {
        const newDate = moment(date).add(543, "years").format("DD/MM/YYYY");
        return newDate;
      } else  if (type == "datetime"){
        const newTime = moment(date).add(543, "years").format("DD/MM/YYYY H:mm:ss");
        return newTime;
      } else {
        const newTime = moment(date).format("LTS");
        return newTime;
      }
    },
    setDateFormatTh(date) {
      const locale = this.$i18n.locale;
      if (locale == "th") {
        const newDate = moment(date)
          .tz("Asia/Bangkok")
          .add(543, "years")
          .format("DD/MM/YYYY H:mm");
        return newDate;
      } else {
        const newDate = moment(date).format("DD/MM/YYYY");
        return newDate;
      }
    },
    maxSelectDate(date) {
      // disables the date if it is a multiple of 5
      if (date.getDate() % 5 == 0) {
        return true;
      }

      // <vs-chip v-if="data[indextr].refuel_event == 1" color="#fdecb4">
      //   <p style="color: #000">เข้าเขตเรือรับน้ำมัน</p>
      // </vs-chip>
      // <vs-chip v-else-if="data[indextr].refuel_event == 2" color="#188d09">
      //   <p>เข้ารับน้ำมัน</p>
      // </vs-chip>
      // <vs-chip v-else-if="data[indextr].refuel_event == 3" color="#ffe1c5">
      //   <p style="color: #000">ออกจากการเข้ารับน้ำมัน</p>
      // </vs-chip>
      // <vs-chip v-else-if="data[indextr].refuel_event == 4" color="#fc7e2a">
      //   <p>ออกนอกเขตเรือจ่ายน้ำมัน</p>
      // </vs-chip>
      // <vs-chip v-else color="gray">
      //   <p>ปกติ</p>
      // </vs-chip>
    },
    async isActiveNotification(data) {
      this.$vs.loading();

      if (data.refuel_event == 1) {
        data.to_s = `<p>ชื่อเรือ: ${data.vessel.name} <br/> 
          MMSI: ${data.vessel.mmsi}<br/>
          วันที่: ${this.setDateFormatTh(data.record_time)}<br/>
          เวลา: ${this.setDateFormatRecordTime(data.record_time)}</p>
          สถานะ : <b style="color: #FDC200"> เข้าเขตเรือรับน้ำมัน</b><br/>`
      } else if (data.refuel_event == 2){
        data.to_s = `<p>ชื่อเรือ: ${data.vessel.name} <br/> 
          MMSI: ${data.vessel.mmsi}<br/>
          วันที่: ${this.setDateFormatTh(data.record_time)}<br/>
          เวลา: ${this.setDateFormatRecordTime(data.record_time)}</p>
          สถานะ : <b style="color: #188d09"> เข้ารับน้ำมัน</b><br/>`
      } else if (data.refuel_event == 3){
        data.to_s = `<p>ชื่อเรือ: ${data.vessel.name} <br/> 
          MMSI: ${data.vessel.mmsi}<br/>
          วันที่: ${this.setDateFormatTh(data.record_time)}<br/>
          เวลา: ${this.setDateFormatRecordTime(data.record_time)}</p>
          สถานะ : <b style="color: #FF7B00"> ออกจากการเข้ารับน้ำมัน</b><br/>`
      } else if (data.refuel_event == 4){
        data.to_s = `<p>ชื่อเรือ: ${data.vessel.name} <br/> 
          MMSI: ${data.vessel.mmsi}<br/>
          วันที่: ${this.setDateFormatTh(data.record_time)}<br/>
          เวลา: ${this.setDateFormatRecordTime(data.record_time)}</p>
          สถานะ : <b style="color: #B84A00"> ออกนอกเขตเรือจ่ายน้ำมัน</b><br/>`
      } else {
        data.to_s = `<p>ชื่อเรือ: ${data.vessel.name} <br/> 
          MMSI: ${data.vessel.mmsi}<br/>
          วันที่: ${this.setDateFormatTh(data.record_time)}<br/>
          เวลา: ${this.setDateFormatRecordTime(data.record_time)}</p>
          สถานะ : <b> ปกติ</b><br/>`
      }

      // this.$router.push(`/monitoring`);
      // await this.$store.dispatch("rts/setPositionEventNotification", data);
      // this.$vs.loading.close();

      localStorage.setItem('setPositionEventNotification', JSON.stringify(data))
      window.open(`/admin/monitoring`, '_blank')
      await this.$store.dispatch('rts/setPositionEventNotification', data)
      this.$vs.loading.close()
    },
  },
};
</script>

<style></style>
